export default {
    methods: {
        formatearFecha(fecha){
            // devuelve una fecha tipo: 2020-08-06T17:24:13.000000Z en formato: 06/08/2020 19:24
            let formato = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }
            let fechaFormateada = new Date(fecha).toLocaleDateString('es-ES', formato);
            return fechaFormateada;
        },
        formatearHora(fecha){
            // convierte una fecha tipo: 2020-08-06T17:24:13.000000Z en una hora en formato: 17:24
            return fecha.toLocaleTimeString('es-ES', {
                hour12: false,
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        formatarFecha (fecha) { //devuelve una fecha tipo: YYYY-MM-DD en formato: DD/MM/YYYY
            fecha = fecha.split(' ')[0];
            const [year, month, day] = fecha.split('-');
            return `${day}/${month}/${year}`;
        },
        parseDate (fecha) { //devuelve una fecha tipo: DD/MM/YYYY en formato: YYYY-MM-DD
            const [day, month, year] = fecha.split('/');
            return `${year}-${month}-${day}`;
        },
    }
}